export const stateName = 'searchSuggestions';